import { forwardRef, type Ref, type SVGProps } from "react";
const IconVolumeMutedFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15.693 6.908a.97.97 0 0 1 1.065-.144c.351.17.575.537.576.94v16.593c0 .402-.225.768-.576.939a.97.97 0 0 1-1.065-.144l-5.721-4.944H6.334c-.553 0-1-.465-1-1.037v-6.222c0-.572.447-1.037 1-1.037h3.638z" />
    <path d="M24.702 12.77a1.001 1.001 0 0 1 1.407 1.407l-.069.076-1.96 1.96 1.96 1.959.07.075a1 1 0 0 1-1.408 1.408l-.076-.07-1.96-1.959-1.959 1.96-.075.069a1 1 0 0 1-1.408-1.408l.07-.075 1.959-1.96-1.96-1.96-.069-.075a1.001 1.001 0 0 1 1.408-1.407l.075.069 1.96 1.96 1.96-1.96z" />
  </svg>
);
const ForwardRef = forwardRef(IconVolumeMutedFilledSVG);
ForwardRef.displayName = "IconVolumeMutedFilled";
export { ForwardRef as IconVolumeMutedFilled };
